import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import USER_ROLES from '../common/userroles';
import Console from '../console';
import { withTranslation } from 'react-i18next';

const styles = (theme) => ({
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginTop: 30,
    marginBottom: theme.spacing(1),
    paddingRight: theme.spacing(2),
  },
  typography: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '2.125rem',
    fontWeight: 400,
    lineHeight: '1.20588em',
    marginLeft: '1rem',
  },
  iframe: {
    width: '100%',
    height: 'calc(100vh - 150px)',
    border: 0,
  },
  switchBtn: {
    textTransform: 'none',
    fontWeight: 600,
    backgroundColor: '#0a5d66',
    color: '#fff',
    marginRight: theme.spacing(2),
    '&:hover': {
      backgroundColor: '#084a52',
    },
  },
});

/**
 * Legacy Limitless iframe dashboard.
 * Toggle preference is owned by DashboardGate (localStorage key: dashboardUi).
 */
class DashboardLegacy extends Component {
  render() {
    const { classes, t, onSwitchUi } = this.props;
    let isDeliveryTech = false;
    try {
      isDeliveryTech =
        JSON.parse(sessionStorage.getItem('permissionUser')) ===
        USER_ROLES.DELIVERYTECH;
    } catch (e) {
      // ignore
    }

    if (isDeliveryTech) {
      return <Console />;
    }

    return (
      <div>
        <Box className={classes.titleRow}>
          <Typography variant="display1" gutterBottom className={classes.typography}>
            {t('Leftbar.Dashboard')}
          </Typography>
          <Button
            variant="contained"
            size="small"
            className={classes.switchBtn}
            onClick={() => onSwitchUi && onSwitchUi('new')}
          >
            Switch to New UI
          </Button>
        </Box>
        <div>
          <iframe
            className={classes.iframe}
            allowtransparency="true"
            title={t('Leftbar.Dashboard')}
            src={
              '/static/dashboard/layout_1/LTR/material/full/index.html#' +
              process.env.REACT_APP_BASEURL
            }
          />
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(DashboardLegacy));



// WEBPACK FOOTER //
// ./src/components/dashboardLegacy/index.js